<template>
  <v-container grid-list-xl rounded class="pa-5 background">
    <v-row class="pa-0">
      <v-col
        cols="12"
        v-if="
          isCan('organisasi.update') &&
            this.current_organisasi &&
            (current_organisasi.is_normalisasi_kuota || current_organisasi.is_user_plot)
        "
      >
        <m-alert show color="blue" title="Informasi">
          <template v-slot:default>
            <v-row justify="center" align="center" class="pa-1">
              <v-col
                cols="12"
                sm="12"
                md="9"
                lg="9"
                v-if="current_organisasi.is_normalisasi_kuota"
              >
                Terima kasih telah menggunakan layanan Masook,saat ini instansi
                Anda terdeteksi memiliki
                <strong
                  >kelebihan pengguna
                  {{
                    current_organisasi.jml_user - current_organisasi.kuota
                  }}</strong
                >
                dari total kuota berlangganan {{ current_organisasi.kuota }}.
                Segera lakukan penambahan kuota atau non aktifkan pengguna Anda
                sampai batas maksimal kuota berlangganan Anda
                <strong>sebelum tanggal {{ pVal(current_organisasi, "batas_normalisasi") | toSD }}.</strong>
              </v-col>
              <v-col
                cols="12"
                sm="12"
                md="9"
                lg="9"
                v-else-if="current_organisasi.is_user_plot"
              >
                Proses perpanjangan/berlangganan telah dilakukan kembali
                sejumlah
                <strong>
                  {{ current_organisasi.kuota_plotting.kuota }} kuota
                </strong>
                untuk <strong>{{ current_organisasi.nama }}</strong
                >. Untuk dapat melakukan presensi kembali silakan pilih
                <strong> Anggota yang akan Diaktifkan </strong> terlebih dahulu
                sebelum
                <strong>{{
                  current_organisasi.tgl_berlaku_akhir | toDT
                }}</strong
                >, karena jumlah Anggota Anda lebih banyak dibandingkan jumlah
                kuota tersedia.
              </v-col>
              <v-col cols="12" sm="12" md="10" lg="10" v-else>
                Terima kasih, Anda telah mengaktifkan
                <strong>{{ current_organisasi.jml_user_plot }}</strong> Anggota,
                Anda memiliki
                <strong
                  >{{
                    current_organisasi.kuota_plotting.kuota -
                      current_organisasi.jml_user_plot
                  }}
                  kuota tersisa</strong
                >. Selanjutnya Anda dapat melakukan perubahan plotting Anggota
                sebelum
                <strong>{{
                  current_organisasi.kuota_plotting.start_at | toDT
                }}</strong>
                WIB pada tombol disamping ini.
              </v-col>
              <v-col cols="12" sm="12" md="2" lg="2">
                <m-button
                  depressed
                  :text="
                    current_organisasi.is_user_plot
                      ? 'Ubah Data'
                      : 'Atur Sekarang'
                  "
                  :large="false"
                  color="info"
                  action="close"
                  @close="toPlotting()"
                ></m-button>
              </v-col>
            </v-row>
          </template>
        </m-alert>
      </v-col>
      <v-col cols="12" sm="6" md="4" lg="4">
        <v-card class="pa-5 elevation-custom text--black" id="kodeorganisasi" style="height: 100%">
          <div
            class="d-flex mb-6"
          >
            <div>
              <h2>{{ current_organisasi.nama }}</h2>
            </div>
            <div class="ml-auto">
              <v-avatar  :size="100" color="grey lighten-4">
                <img
                  :src="current_organisasi && current_organisasi.file_foto
                    ? current_organisasi.file_foto
                    : 'img/organisasi-default.png'"
                  alt="avatar"
                />
              </v-avatar>
            </div>
          </div>
          <div class="subheader font-weight-bold primary--text">
            Kode Registrasi
          </div>
          <div class="caption text-left">
            <span
              >ID Tenant
              &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;:</span
            >
            <span class="font-weight-bold">
              {{ this.current_organisasi.kode_tenant }}</span
            >
          </div>
          <div class="caption text-left">
            <span>ID Organisasi &nbsp;&nbsp;:</span>
            <span class="font-weight-bold">
              {{ this.current_organisasi.kode_organisasi }}</span
            >
          </div>
          <div class="caption text-left">
            <span>Kode Operator :</span>
            <span class="font-weight-bold"> {{ this.current_user.kode }}</span>
          </div>

          <v-divider class="my-5"></v-divider>

          <div v-if="current_organisasi.is_langganan">
            <v-list class="blue lighten-5">
              <v-list-item>
                <v-list-item-avatar>
                  <v-icon size="30" color="primary">mdi-calendar-clock</v-icon>
                </v-list-item-avatar>
                <v-list-item-content>
                  <div class="body-2 font-weight-bold">Informasi Berlangganan</div>
                  <div class="caption">{{ calcTanggal.sisa }} hari lagi / sampai {{ pVal(current_organisasi, "tgl_berlaku_akhir") | toSD }}</div>
                  <div class="mt-1">
                    <v-progress-linear rounded :value="calcTanggal.progress" height="10" color="teal"></v-progress-linear>
                  </div>
                </v-list-item-content>
              </v-list-item>
            </v-list>
          </div>
        </v-card>
      </v-col>
      <v-col cols="12" sm="6" md="8" lg="8">
        <v-row>
          <v-col cols="12" md="6" lg="6">
            <v-card style="height: 100%">
              <v-card-text class="pa-0">
                <v-list>
                  <v-list-item v-if="is_simpatika && current_organisasi.is_langganan">
                    <v-list-item-avatar size="50" color="blue lighten-4">
                      <v-icon size="30" color="blue">mdi-account-multiple</v-icon>
                    </v-list-item-avatar>
                    <v-list-item-content>
                      <div class="display-1 font-weight-bold">{{ $currency(stat.total_kuota || 0) }}</div>
                      <div class="subheader">Kuota Pengguna Biometrik</div>
                    </v-list-item-content>
                  </v-list-item>
                  <v-list-item v-if="is_simpatika && current_organisasi.is_langganan">
                    <v-list-item-avatar size="50" color="cyan lighten-4">
                      <v-icon size="30" color="cyan">mdi-face-recognition</v-icon>
                    </v-list-item-avatar>
                    <v-list-item-content>
                      <div class="display-1 font-weight-bold">{{ $currency(calcBiometrik) || 0 }}</div>
                      <div class="subheader">Pengguna Biometrik</div>
                    </v-list-item-content>
                  </v-list-item>
                  <v-list-item>
                    <v-list-item-avatar size="50" color="green lighten-4">
                      <v-icon size="30" color="green">mdi-account-multiple-check</v-icon>
                    </v-list-item-avatar>
                    <v-list-item-content>
                      <div class="display-1 font-weight-bold">{{ $currency(stat.total_user_aktif || 0) }}</div>
                      <div class="subheader">Pengguna Aktif</div>
                    </v-list-item-content>
                  </v-list-item>
                  <v-list-item>
                    <v-list-item-avatar size="50" color="orange lighten-4">
                      <v-icon size="30" color="orange">mdi-account-multiple-remove</v-icon>
                    </v-list-item-avatar>
                    <v-list-item-content>
                      <div class="display-1 font-weight-bold">{{ $currency(stat.total_user_non_aktif || 0) }}</div>
                      <div class="subheader">Pengguna Tidak Aktif</div>
                    </v-list-item-content>
                  </v-list-item>
                  <v-list-item>
                    <v-list-item-avatar size="50" color="purple lighten-4">
                      <v-icon size="30" color="purple">mdi-account-group</v-icon>
                    </v-list-item-avatar>
                    <v-list-item-content>
                      <div class="display-1 font-weight-bold">{{ $currency(stat.total_user || 0) }}</div>
                      <div class="subheader">Total Pengguna</div>
                    </v-list-item-content>
                  </v-list-item>
                  <v-list-item v-if="!is_simpatika">
                    <v-list-item-avatar size="50" color="purple lighten-4">
                      <v-icon size="30" color="purple">mdi-face-recognition</v-icon>
                    </v-list-item-avatar>
                    <v-list-item-content>
                      <div class="display-1 font-weight-bold">{{ $currency(stat.total_kuota || 0) }}</div>
                      <div class="subheader">Kuota</div>
                    </v-list-item-content>
                  </v-list-item>
                </v-list>

                <v-divider class="my-1"></v-divider>
                <p class="caption grey--text font-italic pa-5">
                  data diambil terakhir 1 jam yang lalu ...
                </p>
              </v-card-text>
            </v-card>
          </v-col>
          <v-col cols="12" md="6" lg="6">
            <v-card class="pa-0 py-0">
             <v-card-text class="py-0">
               <v-list class="py-0">
                 <v-list-item>
                   <v-list-item-action>
                     <v-progress-circular
                       :rotate="360"
                       :size="70"
                       :width="8"
                       :value="calcPengguna"
                       color="purple"
                     >
                       {{ calcPengguna }}%
                     </v-progress-circular>
                   </v-list-item-action>
                   <v-list-item-content>
                     <div class="mt-5">
                       <div class="body-2">
                         <b>{{ $currency(stat.user_verified || 0) }}</b> Sudah Verifikasi Wajah
                       </div>
                       <div class="body-2">
                         <b>{{ $currency(stat.user_not_verified || 0) }}</b> Belum Verifikasi Wajah
                       </div>
                       <v-divider class="my-2"></v-divider>
                       <p class="caption grey--text font-italic">
                         Data diperbarui 1 jam yang lalu
                       </p>
                     </div>
                   </v-list-item-content>
                 </v-list-item>
               </v-list>
             </v-card-text>
           </v-card>
            <v-card class="pa-0 my-2">
              <v-card-text class="py-0">
                <v-list class="py-0">
                  <v-list-item>
                    <v-list-item-avatar size="60" color="purple lighten-4">
                      <v-icon size="40" color="purple">mdi-tablet-cellphone</v-icon>
                    </v-list-item-avatar>
                    <v-list-item-content>
                      <div class="mt-5">
                        <div class="display-1 font-weight-bold">{{ $currency(stat.total_perangkat || 0) }}</div>
                        <div class="subheader">Perangkat Presensi</div>
                        <v-divider class="my-2"></v-divider>
                        <p class="caption grey--text font-italic">
                          Data diperbarui 1 jam yang lalu
                        </p>
                      </div>
                    </v-list-item-content>
                  </v-list-item>
                </v-list>
              </v-card-text>
            </v-card>
            <v-card v-if="is_simpatika" class="pa-0 py-0">
              <v-card-text class="py-0">
                <v-list class="py-0">
                  <v-list-item class="py-0">
                    <v-list-item-avatar size="60" color="purple lighten-4">
                      <v-icon size="40" color="purple">mdi-home-city</v-icon>
                    </v-list-item-avatar>
                    <v-list-item-content>
                      <div class="mt-5">
                        <div class="display-1 font-weight-bold">{{ $currency(stat.jumlah_organisasi_tenant || 0) }}</div>
                        <div class="subheader">Organisasi Dalam Tenant</div>
                        <v-divider class="my-2"></v-divider>
                        <p class="caption grey--text font-italic">
                          Data diperbarui 1 jam yang lalu
                        </p>
                      </div>
                    </v-list-item-content>
                  </v-list-item>
                </v-list>
              </v-card-text>
            </v-card>
          </v-col>
        </v-row>
      </v-col>
    </v-row>
    <v-row wrap>
      <v-col cols="12" id="peta" class="mt-5">
        <v-card class="pa-5 elevation-custom">
          <div class="title">Persebaran Presensi</div>
          <p class="caption grey--text">
            data diambil terakhir 1 jam yang lalu ...
          </p>
          <v-card class="mt-5">
            <div class="iframe-container" :style="{ height: '400px' }">
              <v-map
                :zoom="10"
                :center="center"
                style="position:absolute;z-index:0;"
              >
                <v-icondefault></v-icondefault>
                <v-tilelayer
                  url="http://{s}.tile.osm.org/{z}/{x}/{y}.png"
                ></v-tilelayer>
                <v-marker-cluster :options="clusterOptions">
                  <v-marker
                    v-for="l in locations"
                    :key="l.id"
                    :lat-lng="l.latlng"
                    :icon="icon"
                  >
                    <v-popup :content="l.text"></v-popup>
                  </v-marker>
                </v-marker-cluster>
              </v-map>
            </div>
          </v-card>
        </v-card>
      </v-col>
      <v-col cols="12" sm="12" md="6" xl="6" lg="6">
        <MChartBar
          class="elevation-custom"
          title="Top 5 Penggunaan Perangkat Instansi"
          :op-series="mesin.data"
          :op-legend="false"
          :op-label="mesin.label"
        />
      </v-col>
      <v-col cols="12" sm="12" md="6" lg="3" xl="3">
        <MChartPie
          class="elevation-custom"
          title="Perangkat Instansi"
          :op-data="perangkat.data"
          :op-legend="perangkat.legend"
        />
      </v-col>
      <v-col cols="12" sm="12" md="6" lg="3" xl="3">
        <MChartPie
          class="elevation-custom"
          title="Jenis Kelamin"
          :op-data="gender.data"
          :op-legend="gender.legend"
        />
      </v-col>
    </v-row>
    <m-page-guide
      :steps="steps"
      :show="showGuide"
      action="toProfil"
      @toProfil="toProfil"
    />
<!--    <InfoLangganan />-->
<!--    <InfoKuota ref="infokuota" />-->
    <NotifikasiKetidakhadiran ref="infoKetidakhadiran" />
    <VPlotting ref="dlg" />
    <PopupDaftarGrup ref="popupgrup"/>
    <NPlotting ref="notifkuota" />
    <info-nonaktif ref="infononaktif"/>
  </v-container>
</template>

<script>

import moment from "moment";
import BlockCard from "@/components/BlockCard";
import MChartLine from "@/components/MChartLine";
import MChartPie from "@/components/MChartPie";
import MChartBar from "@/components/MChartBar";
// import InfoLangganan from "@/modules/404/pages/InfoLangganan.vue";
// import InfoKuota from "../components/Kuota";
import NPlotting from "@/modules/404/pages/NotifikasiPlotting";
import VPlotting from "../../user/components/FormPlotting";
import InfoNonaktif from "../components/NonAktif"

import * as Vue2Leaflet from "vue2-leaflet";
import { latLng, Icon, icon } from "leaflet";
import Vue2LeafletMarkercluster from "vue2-leaflet-markercluster";
import iconUrl from "leaflet/dist/images/marker-icon.png";
import shadowUrl from "leaflet/dist/images/marker-shadow.png";
// import {isCan} from "@/tools";

delete Icon.Default.prototype._getIconUrl;
Icon.Default.mergeOptions({
  iconRetinaUrl: require("leaflet/dist/images/marker-icon-2x.png"),
  iconUrl: require("leaflet/dist/images/marker-icon.png"),
  shadowUrl: require("leaflet/dist/images/marker-shadow.png")
});

// const lc = window.localStorage;
// const GUIDE = "GUIDE";

export default {
  components: {
    BlockCard,
    MChartLine,
    MChartPie,
    MChartBar,
    NPlotting,
    VPlotting,
    InfoNonaktif,
    NotifikasiKetidakhadiran: () => import('../components/NotifikasiKetidakhadiran'),
    "v-map": Vue2Leaflet.LMap,
    "v-tilelayer": Vue2Leaflet.LTileLayer,
    "v-icondefault": Vue2Leaflet.LIconDefault,
    "v-marker": Vue2Leaflet.LMarker,
    "v-popup": Vue2Leaflet.LPopup,
    "v-marker-cluster": Vue2LeafletMarkercluster,
    PopupDaftarGrup: () => import('../components/Grup')
  },
  data() {
    let customicon = icon(
      Object.assign({}, Icon.Default.prototype.options, { iconUrl, shadowUrl })
    );
    return {
      locations: [],
      icon: customicon,
      clusterOptions: {},
      stat: {},
      showGuide: false,
      perangkat: {
        legend: ["Aktif", "Tidak Aktif"],
        data: []
      },
      mesin: {
        label: "",
        data: []
      },
      gender: {
        legend: ["L", "P"],
        data: []
      },
      items: [],
      page: null,
      cp: 1,
      headers: [
        { text: "Nama", align: "left", value: "nama" },
        { text: "Tipe Jadwal", align: "left", value: "k_tipe_jadwal" },
        { text: "Berakhir Pada", align: "left", value: "tgl_berakhir" }
      ],
      zoom: 13,
      center: latLng(-6.175174, 106.827173),
      url: "https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png",
      markerLatLng: [],
      steps: [
        // {
        //   element: "#pilihorganisasi",
        //   position: "left",
        //   intro: "Anda dapat memilih organisasi Anda disini"
        // },
        {
          element: "#kodeorganisasi",
          intro:
            "Berikut Adalah <strong>kode organisasi</strong> dan <strong>kode operator</strong> yang dapat Anda gunakan untuk pendaftaran perangkat pengguna",
          position: "right"
        },
        {
          element: "#peta",
          intro:
            "Berikut Adalah <strong>Persebaran Presensi</strong> yang terekam pada perangkat organisasi Anda",
          position: "bottom"
        }
      ]
    };
  },
  computed: {
    calcPengguna() {
      const result = ((this.stat.user_verified || 0) * 100) / (this.stat.total_user) || 0
      return Number(result).toFixed(0)
    },

    calcTanggal() {
      const awal = new Date(this.current_organisasi && this.current_organisasi.tgl_berlaku_awal)
      const akhir = new Date(this.current_organisasi && this.current_organisasi.tgl_berlaku_akhir)
      const now = new Date()
      const total = Math.floor((akhir - awal) / 86400000)
      const sisa = Math.floor((akhir - now) / 86400000)
      const result = Number((sisa * 100) / total).toFixed(0)

      return {
        sisa: sisa < 0 ? 0 : sisa,
        progress: sisa <= 0 ? 0 : 100 - result
      }
    },

    calcBiometrik() {
      const count = Number(this.stat.total_kuota || 0) - Number(this.stat.sisa_kuota_langganan || 0)
      return count < 0 ? 0 : count
    }
  },
  activated() {
    window.scrollTo(0, 0);
  },
  mounted() {
    this.checkGuide();
    Promise.all([
      this.loadStatistik(),
      this.loadGender(),
      this.loadPerangkat(),
      this.loadTop5Perangkat(),
      this.loadPersebaranPresensi(),
    ])

    setTimeout(() => {
      this.$nextTick(() => {
        this.clusterOptions = { disableClusteringAtZoom: 11 };
      });
    }, 5000);
  },

  methods: {
    checkGuide() {
      // var check = lc.getItem(GUIDE);
      // if (typeof check == "undefined" || check == null) {
      //   lc.setItem(GUIDE, true);
      //   this.showGuide = true;
      // } else {
      //   this.showGuide = check == "true" ? true : false;
      // }
      return false;
    },
    reload() {
      Promise.all([
        this.loadStatistik(),
        this.loadGender(),
        this.loadPerangkat(),
        this.loadTop5Perangkat(),
      ]);
    },
    loadProfile() {
      if (this.current_user.is_admin === 1 || this.current_user.is_viewer === 1) return
      this.$store
        .dispatch('user/detail', {
          organisasi_id: this.current_organisasi.kode_organisasi,
          user_id: this.current_user.user_id,
        })
        .then(({ data }) => {
          if ((data && data.is_aktif) === 0) {
            this.$refs.infononaktif.open()
          }
        })
        .catch((e) => e)
    },
    loadStatistik() {
      this.$store
        .dispatch("laporan/statistik", this.organisasi_id)
        .then(res => {
          this.stat = res.data;
        })
        .then(() => {
          // if(this.stat.is_notifikasi_absen){
          //   this.$refs.infoKetidakhadiran.open(this.stat);
          // }
          // const user = (this.stat && this.stat.total_user) || 0;
          // const kuota = (this.stat && this.stat.total_kuota) || 0;
          // const total = kuota - user;

          // if (
          //   [100, 50, 20, 10].includes(total) &&
          //   this.current_user.is_admin === 1
          // ) {
          //   const session = JSON.parse(localStorage.getItem("kuota")) || null;
          //   if (!session) {
          //     this.$refs.infokuota.open(total);
          //   } else if (Number(session && session.kuota) !== total) {
          //     this.$refs.infokuota.open(total);
          //   }
          // }
        });
    },
    loadGender() {
      this.$store
        .dispatch("laporan/statistikUserByGender", this.organisasi_id)
        .then(res => {
          this.gender.data = [
            { value: res.data.wanita, name: "L" },
            { value: res.data.pria, name: "P" }
          ];
        });
    },
    loadPerangkat() {
      this.$store
        .dispatch("laporan/statistikPerangkat", this.organisasi_id)
        .then(res => {
          this.perangkat.data = [
            { value: res.data.aktif, name: "Aktif" },
            { value: res.data.non_aktif, name: "Tidak Aktif" }
          ];
        });
    },
    loadTop5Perangkat() {
      this.$store
        .dispatch("laporan/top5perangkat", this.organisasi_id)
        .then(res => {
          const a = [];

          res.data.forEach(function(item) {
            a.push({
              name: item.nama,
              data: [item.hit]
            });
          });
          this.mesin.data = a;
        });
    },
    loadPersebaranPresensi() {
      this.$store
        .dispatch("riwayatKehadiran/getLokasiPresensis", {
          kode_organisasi: this.organisasi_id,
          params: {
            jml_hari: 50
          }
        })
        .then(res => {
          this.center =
            res.data.length > 0
              ? latLng(res.data[0].latitude, res.data[0].longitude)
              : latLng(-6.175174, 106.827173);
          res.data.forEach(item => {
            var waktuScan = moment(item.waktu_scan).format("DD-MM-YYYY HH:mm");
            var a = {
              id: item.presensi_id,
              latlng: latLng(
                item.latitude ? item.latitude : 0,
                item.longitude ? item.longitude : 0
              ),
              text: item.nama + ", " + waktuScan + " WIB"
            };
            this.locations.push(a);
          });
        })
        .catch(e => e);
    },
    toProfil() {
      this.$router.push({ name: "organisasi.detail" });
    },
    toPlotting() {
      if (this.current_organisasi.is_normalisasi_kuota) {
        this.dialog = false;
        this.isOpen = false;
        this.$router.push({
          name: "user",
          params: {
            organisasi_id: this.organisasi_id
          }
        });
      } else {
        this.dialog = false;
        this.$refs.dlg.open().then(() => {
          this.isOpen = false;
        });
      }
    },
    onCheckGroup() {
      if (!this.isCan('group.index')) return
      this.$refs.popupgrup.open()
    }
  },
  watch: {
    organisasi_id() {
      this.reload();
    }
  }
};
</script>
<style scoped>
@import "~leaflet/dist/leaflet.css";
@import "~leaflet.markercluster/dist/MarkerCluster.css";
@import "~leaflet.markercluster/dist/MarkerCluster.Default.css";
html,
body {
  height: 100%;
  margin: 0;
}
.iframe-container {
  overflow: hidden;
  position: relative;
}

.iframe-container iframe {
  border: 0;
  height: 100%;
  left: 0;
  position: absolute;
  top: 0;
  width: 100%;
}

.elevation-custom {
  -webkit-box-shadow: 0px 0px 20px 3px #4362be56 !important;
}
</style>
